module.exports = __webpack_public_path__ + "media/coffee-preferences/sub_flavor_floral_black_tea-7af98df5.png";